module.exports = __webpack_public_path__ + "static/media/33.994e7a0b.jpg";